export default "__VITE_ASSET__Dl4gM1Xq__"